<template>
  <v-sheet v-if="!period" class="d-flex justify-center align-center flex-column" width="100%">
    <v-btn class="mb-2" v-on:click="go_to_editor()" variant="outlined" color="green">В РЕДАКТОР</v-btn>
    <GrdnCalendar v-model="period" week-picker hide-periods title="ВЫБЕРИ 1 НЕДЕЛЮ"/>
  </v-sheet>
  <v-sheet v-if="period && !documents" class="d-flex justify-center align-center flex-column" width="100%">
    <Loader />
  </v-sheet>
  <v-sheet v-if="week_generated">
    <v-sheet class="hidden_on_print">
      <v-autocomplete
          rounded="0"
          label="Контрагент"
          :items="applicants"
          v-model="applicant"
          item-title="name"
          item-value="guid"
          clearable
      >
        <template v-slot:prepend>
          <v-btn v-on:click="go_to_editor()" height="100%" flat rounded="0" color="grey-lighten-4">В РЕДАКТОР</v-btn>
        </template>
        <template v-slot:append>
          <grdn-toggle v-model="hidden_weekends">
            <p style="font-size: 12px">
              <span v-if="hidden_weekends">ОТОБРАЗИТЬ</span>
              <span v-if="!hidden_weekends">СКРЫТЬ</span>
              <br>
              ВЫХОДНЫЕ
            </p>
          </grdn-toggle>
        </template>
      </v-autocomplete>
    </v-sheet>

    <v-sheet class="every_page d-flex justify-space-between align-start mb-5">
      <v-sheet>
        <p v-if="period">
          План работ на период с <span class="font-weight-bold">{{ moment(period.start).format('DD MMM YYYY') }}</span> по <span class="font-weight-bold">{{ moment(period.end).format('DD MMM YYYY') }}</span>
        </p>
        <p v-if="applicant">
          Контрагент: <span class="font-weight-bold">{{ applicants.find(el=> el.guid === applicant).name }}</span>
        </p>

      </v-sheet>

      <v-sheet style="font-size: 10px" class="d-flex">
        <ul class="mx-1">
          <li><v-icon icon="fa-solid fa-arrow-up-right-dots"  style="color: #c34d1c"/> - Высокий приоритет</li>
          <li><v-icon icon="fa-solid fa-triangle-exclamation" /> - Инцидент (аварийное обращение)</li>
          <li><v-icon icon="fa-solid fa-toolbox" /> - Заявка на дополнительные / прочие работы</li>
          <li><v-icon icon="fa-solid fa-chalkboard-user" /> - Заявка на отчет, инструктаж, помощь</li>
          <li><v-icon icon="fa-solid fa-helmet-safety" /> - Заявка на СМР / ПНР</li>
        </ul>
        <ul class="mx-1">
          <li><v-icon icon="fa-solid fa-hand-holding-hand" /> - Заявка на доп.испытание</li>
          <li><v-icon icon="fa-solid fa-hand-holding-medical" /> - Заявка на доп.техническое обслуживание</li>
          <li><v-icon icon="fa-solid fa-screwdriver-wrench" /> - Тех. обслуживание</li>
          <li><v-icon icon="fa-solid fa-clipboard-check" /> - Испытания</li>
          <li><v-icon icon="fa-solid fa-circle-notch" /> - Другие обращения</li>
        </ul>
      </v-sheet>
    </v-sheet>




    <v-row style="border-top: dotted rgba(0,0,0,0.5) 1px">
      <template v-for="(day, index) in week_generated" :key="day">
        <v-col v-if="hidden_weekends ? (index < 5) : true" class="mb-4" :class="{'has-left-border' : index > 0 }">
          <p class="mb-2 text-center"><span class="font-weight-bold">{{ moment(day.date).format('DD.MM.YYYY') }}</span> {{ moment(day.date).startOf('days').format('dd') }}</p>
          <template v-if="day && day.docs">
            <template v-for="doc in day.docs" :key="doc">
              <v-card variant="outlined" class="mb-1 prevent_break" :color="doc.doc_type === 'Проведение ТО и ППР' ? '#3d6e08' : ''" v-if="applicant ? (doc.applicant.guid === applicant) : true">
                <template v-slot:prepend>
                  <v-icon style="color: #c34d1c" class="mr-1" :icon="['fas', 'arrow-up-right-dots']" v-if="doc.priority === 'Высокий (критичный)'" />
                  <v-icon :icon="['fas', get_type_icon(doc.worktype)]" />
                </template>
                <template v-slot:title>
                  <p style="font-size: 12px">
                <span v-if="doc.doc_type === 'Проведение ТО и ППР'">
                  З.Н.
                </span>
                    №{{ doc.number }}
                  </p>
                </template>
                <template v-slot:append>
                  <v-chip variant="text" class="px-2" style="font-size: 12px;" size="20">
                    {{ (doc.duration % 60 === 0) ? doc.duration / 60 : (doc.duration / 60).toFixed(2) }} ч.ч.
                  </v-chip>
                </template>
                <template v-slot:text>
                  <p style="font-size: 10px" class="font-weight-bold">
                    {{ doc.object.short ? doc.object.short : doc.object.name }}
                    <span v-if="doc.location"> - {{ doc.location }}</span>
                  </p>
                  <p style="font-size: 10px" v-if="doc.description">
                    {{ doc.description }}
                  </p>
                </template>
                <pre v-if="false">{{ doc }}</pre>
              </v-card>
            </template>

          </template>
          <p v-else class="text-center">ПЛАН ОТСУТСТВУЕТ</p>
        </v-col>
      </template>
    </v-row>
  </v-sheet>
</template>

<script>
  import { TokenGUIDStore } from "@/store/global/SessionStore"
  import GrdnCalendar from "@/components/grdn/grdn-calendar.vue"
  import Loader from "@/components/Different/Loader.vue"
  import { Allerts } from "@/store/global/Allerts"
  import moment from "moment/moment";
  import { District__Info } from "@/store/global/districts.dictionary";
  import GrdnToggle from "@/components/Different/GRDN-Toggle.vue";

  export default {
    name: "PrinterView",
    components: {
      GrdnToggle,
      Loader,
      GrdnCalendar
    },
    beforeMount() {
      /*if (this.$route.query.start && this.$route.query.end) {
        this.period = {
          start:  this.$route.query.start,
          end:    this.$route.query.end
        }
      }*/
    },
    data() {
      return {
        applicant: null,
        hidden_weekends: true,
        period: null,
        documents: []
      } // Зоров Вадим
    },
    watch: {
      async period(value) {
        if (value) {
          //this.$router.push({ name: 'wp__print', params: { district: this.$route.params.district }, query: { start: this.$route.query.start, end: this.$route.query.end }})
          await this.get_period_planned_data()
        }
      }
    },
    methods: {
      moment,
      go_to_editor: function () {
        this.$router.push({ name: 'wp__edit', params: { district: this.$route.params.district } })
      },
      get_type_icon: function (worktype) {
        switch (worktype.name) {
          case 'Инцидент (аварийное обращение)':
            return 'triangle-exclamation'
          case 'Заявка на дополнительные / прочие работы':
            return 'toolbox'
          case 'Заявка на отчет, инструктаж, помощь':
            return 'chalkboard-user'
          case 'Заявка на СМР / ПНР':
            return 'helmet-safety'
          case 'Заявка на испытание':
            return 'hand-holding-hand'
          case 'Заявка на техническое обслуживание':
            return 'hand-holding-medical'
          case 'Техническое обслуживание':
            return 'screwdriver-wrench'
          case 'Испытания':
            return 'clipboard-check'
          default:
            return 'circle-notch'
        }
      },
      get_period_planned_data: async function () {
        let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/WP_GetDataForPrinter`
        let raw = {
          start: this.period.start,
          end: this.period.end,
          district: this.$route.params.district,
        }

        let properies = {
          method: 'POST',
          withCredentials: true,
          headers: {
            "Authorization": "Bearer " + this.session_token
          },
          body: JSON.stringify(raw)
        }
        await fetch(url, properies)
            .then(async response => {
              if (response.ok) {
                return await response.json()
              } else {
                throw `Ошибка получения Документов!`
              }
            })
            .then(result => {
              this.documents = result
            }).catch(err => {
              this.period = null
              this.documents = null
              Allerts().warn('ОШИБКА', err, '#ff0000', 'triangle-exclamation')
              console.error(err)
            })
      },
      get_day_events: function (day) {
        let docs = this.documents.filter(el => {
          if (el && el.date && el.date.desire) {
            return el.date.desire === day
          }
          return false
        })

        if (docs && docs.length > 0) {
          return docs
        } else {
          return false
        }
      }
    },
    computed: {
      applicants() {
        let array = []
        if (this.documents) {
          array = this.documents.map(ev => ev.applicant)
        }

        array = array.filter((value, index) => {
          const _value = JSON.stringify(value);
          return index === array.findIndex(obj => {
            return JSON.stringify(obj) === _value;
          });
        });

        return array
      },
      district_info() {
        return District__Info().get()
      },
      session_token() {
        return TokenGUIDStore().get()
      },
      week_generated() {
        if (this.period && this.period.start) {
          let sd = this.period.start;
          let array = []
          for (let i = 0; i < 7; i++) {
            let date = moment(sd).add(i, 'days').format('YYYY-MM-DD[T]HH:mm:ss')
            array.push({
              date: date,
              docs: this.get_day_events(date)
            })
          }
          return array
        } else {
          return false
        }

      }
    }
  }
</script>

<style>

@media print {
  @page {
    size: landscape;
    margin: 10px 0 0 0;
  }

  @page:first {
    margin: 0 0 0 0;
  }

  .prevent_break {
    page-break-inside: avoid;
  }

  .allow_break {
    page-break-after: auto;
  }

  .hidden_on_print, .hidden_on_print *
  {
    display: none !important;
  }
}

.has-left-border {
  border-left: dotted rgba(0, 0, 0, 0.5) 1px;
}
</style>
